define('areas/home/commands/logincommand',["require", "exports", "plugins/router"], function (require, exports, Router) {
    "use strict";
    var LoginCommand = (function () {
        function LoginCommand() {
        }
        LoginCommand.prototype.execute = function (unit) {
            Router.navigate("login");
            //App.showDialog("areas/account/viewmodels/login");
        };
        return LoginCommand;
    }());
    return LoginCommand;
});

